export default "__VITE_ASSET__31a01278__"